module.exports = __webpack_public_path__ + "static/media/timeline--mobile.82a70ee2.svg";